var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33643 36C9.64843 36 12.3364 33.312 12.3364 30V24H6.33643C3.02443 24 0.336426 26.688 0.336426 30C0.336426 33.312 3.02443 36 6.33643 36Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.336426 18C0.336426 14.688 3.02443 12 6.33643 12H12.3364V24H6.33643C3.02443 24 0.336426 21.312 0.336426 18Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.336426 6C0.336426 2.688 3.02443 0 6.33643 0H12.3364V12H6.33643C3.02443 12 0.336426 9.312 0.336426 6Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3364 0H18.3364C21.6484 0 24.3364 2.688 24.3364 6C24.3364 9.312 21.6484 12 18.3364 12H12.3364V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3364 18C24.3364 21.312 21.6484 24 18.3364 24C15.0244 24 12.3364 21.312 12.3364 18C12.3364 14.688 15.0244 12 18.3364 12C21.6484 12 24.3364 14.688 24.3364 18Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 36,
    fill: "white",
    transform: "translate(0.336426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.d53e01ae5633c7077f07994d39af178d.svg";
export { ForwardRef as ReactComponent };